<template>
  <div
    class="home"
    v-loading="isLoading"
  >
    <app-logo class="home__logo" />
    <div class="home__content">
      <app-i18n
        class="home__content__welcome"
        tag="p"
        code="teamRegistrationSite.home.welcome"
      />

     <div class="home__content__terms">
        <el-checkbox
          v-model="acceptedTerms"
          class="home__content__terms__checkbox"
        >
          <app-i18n code="teamRegistrationSite.home.acceptTermsAndPrivacy" />
        </el-checkbox>
        <el-checkbox
          v-model="acceptedOrganizationPrivacy"
          class="home__content__terms__checkbox"
        >
          <app-i18n code="teamRegistrationSite.home.acceptOrganizationPrivacy" />
        </el-checkbox>
      </div>

      <div class="home__content__start">
        <el-button
          type="primary"
          :disabled="!acceptedTerms || !acceptedOrganizationPrivacy"
          @click="goToForm"
        >
          <app-i18n code="common.start" />
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import AppLogo from '@/components/Logo.vue'

export default {
  name: 'home',
  data() {
    return {
      acceptedOrganizationPrivacy: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('form', ['hasAcceptedTerms']),
    ...mapState('tournament', ['property', 'subproperty']),
    acceptedTerms: {
      set(val) {
        this.$store.commit('form/setAcceptedTerms', val)
      },
      get() {
        return this.hasAcceptedTerms
      },
    },
  },
  mounted() {
    this.set({ key: 'property', val: this.property })
    this.set({ key: 'subproperty', val: this.subproperty })
  },
  methods: {
    ...mapMutations('teamRegistration', ['set']),
    ...mapActions('teamRegistration', ['fetchNewId']),
    async goToForm() {
      this.isLoading = true
      await this.fetchNewId()
      this.isLoading = false

      const { slug } = this.$route.params
      this.$router.push({
        name: 'teamRegistration',
        params: { slug },
      })
    },
  },
  components: {
    AppLogo,
  },
}
</script>

<style lang="scss" scoped>
.home {
  --vertical-margin: 80px;

  background: #fff;

  @include desktop { --vertical-margin: 64px; }

  &__logo {
    margin: var(--vertical-margin) auto;
  }

  &__content {
    padding: 0 8px;
    text-align: center;

    &__welcome {
      margin-bottom: var(--vertical-margin);
      font-weight: 300;
      font-size: 22px;
      text-transform: uppercase;
    }

    &__terms {
      &__checkbox {
        display: inline-flex;
        margin: 0 0 20px;
        font-size: 14px;
        line-height: 1.3;
        white-space: normal;
        text-align: left;

        @include desktop {
          align-items: center;
        }

        &:last-child {
          margin: 0 0 calc(var(--vertical-margin) - 8px);
        }
      }
    }
  }
}
</style>
